import React, { forwardRef } from 'react';
import { Box } from '@dropbox/dig-foundations';
import { FieldContextProvider } from 'signer-app/signature-request/display-field';
import { SignatureModalLine } from 'signer-app/signature-modal/common/signature-modal-line';
import SignaturePlaceholder from 'signer-app/signer-signature-document/signature-placeholder';
import { SignatureField, InitialsField } from 'signer-app/types/editor-types';
import styles from 'signer-app/signer-signature-document/accessible-document.module.css';
import { useAtomValue } from 'jotai';
import { accessibleViewAtom } from '../accessible-document-toggle';
import { FormattedMessage } from 'react-intl';
import { Text } from '@dropbox/dig-components/typography';
import SignatureStandaloneField from '../signature-standalone-field';

export const SignatureFieldComponent = forwardRef<
  HTMLElement,
  {
    field: SignatureField | InitialsField;
    onFocus: () => void;
    'data-form-view-field': string;
  }
>(function SignatureFieldComponent(
  { field, onFocus, 'data-form-view-field': dataFormViewField },
  ref,
) {
  const isFormViewEnabled = useAtomValue(accessibleViewAtom);

  return (
    <FieldContextProvider
      fieldData={field}
      wrapperStyles={{
        height: '100',
        width: '400',
        flex: 'auto',
      }}
      isFormView={true}
    >
      <Box marginBottom="Micro Medium">
        <Text color="subtle" size="medium">
          <FormattedMessage
            id="4a2dd551828c734cb054281c250d4836b06162530e255f37d8d7e60206821e23"
            description="Disclosure text that the user must agree to when signing a document."
            defaultMessage="I understand this is a legal representation of my signature."
          />
        </Text>
      </Box>

      {isFormViewEnabled ? (
        <Box data-form-view-field={dataFormViewField} onFocus={onFocus}>
          <SignatureStandaloneField fieldData={field} ref={ref} />
        </Box>
      ) : (
        <Box
          className={styles.signaturePad}
          width="100%"
          borderStyle="Solid"
          borderColor="Border Base"
          position="relative"
          data-form-view-field={dataFormViewField}
          onFocus={onFocus}
          fontWeight="Strong"
        >
          <Box position="absolute" display="flex" height="100%" width="100%">
            <SignaturePlaceholder
              showDrawerMenu
              isDrawerView={true}
              fieldData={field}
              textScale={14 / 11}
              ref={ref}
            />
          </Box>
          <SignatureModalLine />
        </Box>
      )}
    </FieldContextProvider>
  );
});
